import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastInfo {
  id: string;
  type: ToastType;
  header: string;
  body: string;
  delay: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts = signal<ToastInfo[]>([]);

  success(body: string, header = 'Success', delay = 5000): void {
    this.add('success', body, header, delay);
  }
  error(body: string, header = 'Error', delay = 5000): void {
    this.add('error', body, header, delay);
  }
  warning(body: string, header = 'Warning', delay = 5000): void {
    this.add('warning', body, header, delay);
  }
  info(body: string, header = 'Info', delay = 5000): void {
    this.add('info', body, header, delay);
  }

  private add(type: ToastType, body: string, header: string, delay: number): void {
    const id = Math.random().toString(36).slice(7);
    const toast: ToastInfo = { id, type, header, body, delay };
    this.toasts.update(t => [...t, toast]);
    if (delay > 0) setTimeout(() => this.remove(toast), delay);
  }

  remove(toast: ToastInfo): void {
    this.toasts.update(t => t.filter(x => x.id !== toast.id));
  }
  clear(): void { this.toasts.set([]); }
}
